import React from "react";
import Pagination from '@mui/material/Pagination';
import GlobalContext from "./GlobalContext";

function ResultsPagination(){
  const global = React.useContext(GlobalContext);

  if(global.state.records.length === 0 || global.state.numPages < 2) return false;

  return (
    <div className='pagination-container'>
      <Pagination 
        count={ global.state.numPages } 
        onChange={ global.actions.changePage }
        page={ global.state.page }
        showFirstButton 
        showLastButton 
      />
    </div>
  );
}

export default ResultsPagination;